var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100px","width":"500px","overflow":"scroll"}},_vm._l((_vm.items),function(item){return _c('div',[_vm._v("\n        "+_vm._s('item #' + item)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }